import React from 'react';
import cln from 'classnames';
import './sidebar-tab.scss';

type SidebarTabProps = {
    label: React.ReactElement | string;
    isActive: boolean;
    onClick: () => void;
};

export const SidebarTab = ({ label, isActive, onClick }: SidebarTabProps) => {
    return (
        <button
            className={cln('sidebar-tab', { 'sidebar-tab--active': isActive })}
            onClick={onClick}
        >
            {label}
        </button>
    );
};
